import {all, put, select} from "redux-saga/effects";
import {flushErrorBuffer} from "./actions";
import {IApplicationState} from "../index";
import {delay} from "redux-saga";
import apiCall from "../../shared/utils/apiCall";
import forkWithErrHandler from "../../shared/utils/forkWithErrHandler";

const REQUEST_TIMEOUT = 30000;

function* synchronizationWorker() {
    while (true) {
        const {synchronizationTimeout, errors, metrics, appVersion} = yield select(({ settings, log }: IApplicationState) => ({
            appVersion: settings.appVersion,
            synchronizationTimeout: settings.general.synchronizationTimeout || 0,
            errors: log.errors,
            metrics: log.metrics,
        }));

        yield delay(Math.max(5000, synchronizationTimeout));

        const errorMessages = !window.DISABLE_ERROR_LOGGING
            ? errors
            : [];
        const metricMessages = !window.DISABLE_PERFORMANCE_TRACKING
            ? metrics
            : [];

        if (!errorMessages.length && !metricMessages.length)
            continue;

        try {
            yield apiCall({
                params: {
                    section: "log",
                    method: "post",
                },
                data: {
                    appVersion: appVersion,
                    messages: errorMessages,
                    metrics: metricMessages,
                },
                retryCount: 1,
                requestTimeout: REQUEST_TIMEOUT,
                trackPerformance: false,
            });

            yield put(flushErrorBuffer(new Date().getTime()));
        }
        catch (e) {
            console.error(e);
        }
    }
}

export default function* logSaga() {
    if (window.DISABLE_ERROR_LOGGING) {
        console.warn("[WARN] Error logging is disabled");
    }

    if (window.DISABLE_PERFORMANCE_TRACKING) {
        console.warn("[WARN] Performance tracking is disabled");
    }

    if (!window.DISABLE_ERROR_LOGGING || !window.DISABLE_PERFORMANCE_TRACKING) {
        yield all([
            forkWithErrHandler("logSaga", "synchronizationWorker", synchronizationWorker)
        ]);
    }
}